import React from "react";
import { Container } from "react-bootstrap";
import { MoonLoader } from "react-spinners";
import { COLORS, SITE_CONFIG } from "../Utiles/Constants";

const Loader = ({
  type = "clip",
  size = 50,
  message = "Loading...",
  variant = "primary",
}) => {
  const getColor = () => {
    switch (variant) {
      case "primary":
        return COLORS.primary;
      case "success":
        return COLORS.success;
      default:
        return COLORS.primary;
    }
  };

  return (
    <Container className="vh-100 d-flex flex-column justify-content-center align-items-center">
      <div className="text-center mb-4">
        <h2 className="fw-bold mb-2" style={{ color: COLORS.light }}>
          {SITE_CONFIG.name}
        </h2>
        <p className="text-white-50">WhatsApp Business Automation</p>
      </div>

      <MoonLoader size={size} color={getColor()} />

      {message && (
        <p className="mt-3 text-white-50" style={{ fontWeight: "500" }}>
          {message}
        </p>
      )}
    </Container>
  );
};

export default Loader;
